import styled from 'styled-components'

const HelperIconContainer = styled.div`
  position: fixed;
  bottom: 2%;
  right: 3.4%;
  padding: 1px;
  cursor: pointer;
  height: 60px;
  width: 60px;
  background-color: #45a4ec;
  box-shadow: 0 5px 4px 0 rgb(0 0 0 / 26%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  z-index: 1005;
`
const IconContainer = styled.div`
  border-radius: 50%;
  border: 1px solid #040406;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  z-index: 1000;
`
const FaqIconContainer = styled.div`
  position: fixed;
  bottom: ${({ bottom }) => (bottom ? bottom : '-100px')};
  right: 3.4%;
  height: 50px;
  width: 110px;
  padding: 16px 24px;
  box-shadow: 0 5px 4px 0 rgb(0 0 0 / 26%);
  background-color: var(--TextDark900);
  color: var(--Text500);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 56px;
  z-index: 1;
  cursor: pointer;
  z-index: 1000;
  a {
    color: var(--Text500);
  }
`
export { FaqIconContainer, HelperIconContainer, IconContainer }
